
import PreEntryApi from '../../assets/js/preentry'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
export default {
components: {
XButton,
Flexbox,
FlexboxItem,
Divider,
Loading,
OnboardHeader
},
data () {
return {
id: '',
code: '',
status: '',
has_offer: '',
pre_code_new: '',
pre_pass: '',
is_pre: false, // 预览模式
is_check_pass: false, // 验证信息通过
data: {
format_date: ['', '', ''],
format_nowdate: ['', '', '']
},
showLoading: true
}
},
created () {
this.id = this.$route.query.id
this.pre_pass = this.$route.query.pre_pass
this.pre_code_new = this.$route.query.pre_code_new

var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
this.isZH = localStorage.getItem('offer_zh') === 'zh'
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()


if (!this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}


if (!this.code && !this.pre_pass) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
if (this.pre_pass) {

PreEntryApi.checkPreLogin(
{ id: this.id, code: this.pre_code_new, pre_pass: this.pre_pass },

(data, meta) => {
this.is_pre = true
this.is_check_pass = true
return false
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
).then(data => {
if (!this.is_check_pass) {
return false
}
PreEntryApi.getStatusValue(
{ id: this.id, code: this.pre_code_new },

(data, meta) => {
if (data) {
this.has_offer = data.has_offer
}
}
)

PreEntryApi.getStaffDetail(
{ id: this.id, code: this.pre_code_new, from: 'ehr' },

(data, meta) => {
if (data) {
this.data = data
this.status = data.status
if (this.data.start_date) {
this.data.format_date = this.data.start_date.split('-')
}

if (this.data.now_date) {
this.data.format_nowdate = this.data.now_date.split('-')
}
this.showLoading = false
}
},

err => {
if (err === -2) {
this.$message.error(this.$tsg('详情信息未获取，请刷新当前页面'))
} else {
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
}
this.showLoading = false
return false
},

err => {
this.showLoading = false
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
return false
},

err => {
this.showLoading = false
return false
}
)
})
} else {

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },

(data, meta) => {
this.is_check_pass = true
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
).then(data => {
if (!this.is_check_pass) {
return false
}
PreEntryApi.getStatusValue(
{ id: this.id, code: this.code },

(data, meta) => {
if (data) {
this.has_offer = data.has_offer
}
}
)

PreEntryApi.getStaffDetail(
{ id: this.id, code: this.code },

(data, meta) => {
if (data) {
this.data = data
this.status = data.status
if (this.data.start_date) {
this.data.format_date = this.data.start_date.split('-')
}

if (this.data.now_date) {
this.data.format_nowdate = this.data.now_date.split('-')
}

if (!this.data.bce_offer_url) {
this.createOfferPDF()
} else {
this.showLoading = false
}

this.showLoading = false
}
},

err => {
if (err === -2) {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
}
this.showLoading = false
return false
},

err => {
this.showLoading = false
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
return false
},

err => {
this.showLoading = false
return false
}
)
})
}
},
methods: {
createOfferPDF () {
PreEntryApi.createOfferPDF(
{ id: this.id, code: this.code },

(data, meta) => {
this.showLoading = false
},

err => {
this.showLoading = false
return false
},

err => {
this.showLoading = false
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
return false
},

err => {
this.showLoading = false
return false
}
)
},


downloadOffer () {
window.open(process.env.API_HOST + '/api/v1.0/onboard/download_offer?id=' + this.id + '&code=' + this.code)
},

acceptOffer () {
PreEntryApi.confirmOffer(
{ id: this.id, code: this.code },

(data, meta) => {
if (data !== '') {
this.$message.error(this.$tsg('接受offer失败。'))
return false
}

this.$router.push({ name: 'onboard.school_graduate', query: { id: this.id } })

},

err => {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
}
)
},

refuseOffer () {
this.$router.push({ name: 'onboard.school_refuse', query: { id: this.id } })
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')
} else {
localStorage.setItem('offer_zh', 'en')
}
this.isZH = data
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/school_offer_sh_lxqc.vue